// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"443":"d67c9c2e","606":"d67c9c2e","628":"d67c9c2e","988":"d67c9c2e"}[chunkId] + ".chunk.css";
};